<template>
  <div class="pictureControl">
    <a-spin :spinning="spin">
      <div class="top">
        <!-- 第一部分 -->
        <div class="classTitle">
          <div class="topTitle title">图片分类：</div>
          <div style="display: inline-block" class="content">
            <a-radio-group
              size="small"
              default-value="0"
              button-style="solid"
              @change="onChange"
            >
              <a-radio-button value="0"> 全部 </a-radio-button>
              <a-radio-button value="-1"> 默认分类 </a-radio-button>
              <a-radio-button
                :value="item.id"
                v-for="item in topData"
                :key="item.id"
              >
                {{ item.title }}
              </a-radio-button>
            </a-radio-group>
            <!-- <admin_con @click="loadList" class="iconSheZhi" type="icon-shezhi"/> -->
          </div>
          <a-button
              size="small"
              @click="showModal"
              style="border: none;box-shadow: none;color:#1890ff">
              管理
            </a-button>
        </div>

        <!-- 第二部分 -->
        <div class="selectTop">
          <div style="display: flex">
            <span class="topTitle">素材名称：</span>
            <a-input
              v-model="imgName"
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
            />
          </div>
          <div style="display: flex">
            <span class="topTitle">上传时间：</span>
            <a-range-picker @change="timeChange" v-model="year" />
          </div>
          <div>
            <a-button
              type="primary"
              style="margin-left: 10px; font-size: 14px"
              @click="search"
              >查询</a-button
            >
            <a-button @click="clear" style="margin-left: 20px">重置</a-button>
          </div>
        </div>
      </div>
      <!-- 图 -->
      <div style="width: 100%; height: 10px; background: #edeff2"></div>
      <div class="bottom">
        <!-- 顶部 -->
        <div style="border: 1px solid #edeff2; margin-bottom: 15px">
          <div class="moTitle">
            <div class="topTitle font">图片素材列表</div>
            <div style="margin-top: 9px">
              <a class="file" href="javascript:;" v-if="!MessageShow1"
                >+上传图片
                <input
                  id="files"
                  multiple
                  ref="iconRefs"
                  type="file"
                  accept="image/*"
                  @change="up_iconList('iconRefs')"
                />
              </a>
              <!-- 未认证 -->
              <a
                class="file"
                href="javascript:;"
                v-if="MessageShow1"
                @click="openMessage"
                >+上传图片
              </a>
            </div>
          </div>
        </div>

        <!-- 显示 -->
        <div style="width: 98%; margin: auto; position: relative">
          <a-row :gutter="16" type="flex" justify="start" align="bottom">
            <!-- 空数据 -->
            <div
              v-if="picture.length == 0"
              style="
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
              "
            >
              <NullDataPrompt message="暂无图片"></NullDataPrompt>
            </div>
            <a-col
              v-else
              :span="innerWidths > 0 && innerWidths < 1920 ? 5 : 4"
              style="margin-bottom: 2%"
              v-for="(item, index) in picture"
              :key="item.id"
            >
              <div
                :style="{
                  width:
                    innerWidths > 0 && innerWidths < 1920 ? '100%' : '100%',
                }"
                class="item"
                @mouseenter="showYuan(index)"
                @mouseleave="unshow"
              >
                <!-- 图片 -->
                <div style="width: 100%; height: 75%;background-color: rgba(0,0,0,.85);">
                  <img
                    :src="item.url"
                    style="
                      width: 100%;
                      height: 100%;
                    "
                  />
                </div>
                <!-- 名字 -->
                <!-- <div v-show="index === selectIndex ? true : false">
                  <a-dropdown>
                    <a class="yuan">
                      <a-icon
                        type="ellipsis"
                        style="font-size: 26px; color: rgb(167, 160, 160)"
                      />
                    </a>
                    <a-menu
                      style="margin-left: -50px; margin-top: -3px"
                      slot="overlay"
                      @mouseenter="showYuan(index)"
                      z-index="999"
                    >
                      <a-menu-item @click="changeName(index, item)">
                        重命名
                      </a-menu-item>
                      <a-menu-item @click="changeCategory(item)"
                        >移动分组</a-menu-item
                      >
                      <a-menu-item @click="del(item)"> -->
                <!-- 删除 -->
                <!-- <a-popconfirm
                    title="确认删除图片?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delPicture(item)"
                    @cancel="cancel"
                    style="z-index: 999999; margin-right: 30px"
                  >
                    <span style="display: inline-block; width: 120%">删除</span>
                  </a-popconfirm> -->
                <!-- </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div> -->
                <div
                  class="dropdown"
                  v-show="index === selectIndex ? true : false"
                >
                  <a class="dropdown-button">
                    <a-icon
                      type="ellipsis"
                      style="font-size: 26px; color: rgb(167, 160, 160)"
                    />
                  </a>
                  <div class="dropdown-menu">
                    <a @click="changeName(index, item)"> 重命名</a>
                    <a @click="changeCategory(item)">移动分类</a>
                    <a @click="del(item)">删除</a>
                  </div>
                </div>

                <!-- 名字 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    font-size: 19px;
                    position: absolute;
                    bottom: 37px;
                  "
                >
                  <div
                    v-if="index == inputshow ? false : true"
                    style="
                      width: 98%;
                      margin-top: 5px;
                      margin-left: 7px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-size: 16px;
                      font-weight: 600;
                      color: #333333;
                    "
                  >
                    {{ item.name }}
                  </div>
                  <div
                    v-if="index == inputshow ? true : false"
                    style="width: 100%; height: 50%"
                  >
                    <a-input
                      id="addLabel"
                      v-if="index == inputshow ? true : false"
                      v-model="pictureName"
                      :placeholder="item.name"
                      @pressEnter="changeimgName(item)"
                      @blur="change"
                    >
                    </a-input>
                  </div>
                </div>
                <!-- 时间 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    position: absolute;
                    bottom: 0;
                  "
                >
                  <p :style="{ color: '#333333', marginLeft: '7px' }">
                    {{ item.createdTime }}
                  </p>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <a-pagination
          :current="curPage"
          :total="total"
          :pageSize="pageSize"
          show-quick-jumper
          @change="PageNOchange"
        />
      </div>

      <!-- 移动分组弹窗 -->
      <a-modal
        :visible="visible"
        title="选择分类"
        @ok="handleOk"
        width="30%"
        @cancel="handleCancel"
      >
        <a-radio-group
          button-style="solid"
          :default-value="categoryId"
          :key="categoryId"
          style="padding: 10px 10px 30px 10px"
        >
          <a-radio-button :value="-1" :key="-1" @click="handle(-1)"
            >默认分类</a-radio-button
          >
          <a-radio-button
            :value="item.id"
            v-for="item in topData"
            :key="item.id"
            @click="handle(item.id)"
          >
            {{ item.title }}
          </a-radio-button>
        </a-radio-group>
        <!-- <a-button
        @click="handle(item)"
        v-for="item in topData"
        :key="item.id"
        style="margin-left: 20px"
        >{{ item.title }}</a-button
      > -->
      </a-modal>
      <!-- 删除 -->
      <a-modal
        :visible="delVisible"
        @ok="deleteOk"
        @cancel="delCancel"
        :width="300"
        :height="20"
      >
        <p style="font-size: 18px">确认删除图片？</p>
      </a-modal>
      <!-- 新增对话框 -->
      <a-modal
        title="新增分类"
        :visible="visibleClass"
        @ok="handleOkClass"
        @cancel="handleCancelClass"
        style="width: 200px; height: 130px"
      >
        <a-form-model
          :model="form"
          :rules="addRules"
          ref="ruleForm_add"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              v-model="form.name"
              style="display: flex; margin-top: 5px; width: 220px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!-- 管理弹窗 -->
      <a-modal v-model="modalShow" title="图片分类管理" @ok="handleSubmit" @cancel="modalCancel" width="1000px">
        <!-- <a-spin :spinning="spin"> -->
          <!-- 头部 -->
          <div class="top2">
            <span :style="{ color: variables.topTitleColor }">分类名称：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
              v-model="remark"
            />
            <a-button
              type="primary"
              style="margin-left: 10px; font-size: 14px"
              @click="searchManange"
              >查询</a-button
            >
            <a-button @click="Manageclear" style="margin-left: 20px">重置</a-button>
          </div>
          <!-- 中间 -->
          <!-- <div style="width: 100%; height: 2px; background: #edeff2"></div> -->
          <!-- 列表 -->
          <!-- <div class="liebiao">
            <div class="title">分类列表</div>
          </div> -->
          <div
            :style="{
              width: variables.space_div,
              margin: 'auto',
              paddingTop: variables.LineSpacing,
              paddingBottom: variables.LineSpacing,
            }"
          >
            <a-button type="primary" @click="add1Management">新增</a-button>
          </div>
          <div :style="{ width: variables.space_div, margin: 'auto' }">
            <a-table
              :pagination="false"
              :row-key="(record) => record.id"
              :columns="columnsAdd"
              :dataSource="dataSource"
            >
              <!-- 操作 -->
              <span slot="is_operation" slot-scope="text, record, index">
                <a
                  style="margin-right: 10px; "
                  @click="upMove(record)"
                  v-show="index === 0 ? false : true"
                  >上移</a
                >
                <a
                  style="margin-right: 10px; "
                  @click="downMove(record)"
                  v-show="index === dataSource.length - 1 ? false : true"
                  >下移</a
                >
                <a
                  style="margin-right: 10px; "
                  @click="edit(record)"
                  >编辑</a
                >
                <a-popconfirm
                  title="确定删除?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="delManage(record)"
                >
                  <a >删除</a>
                </a-popconfirm>
              </span>
            </a-table>
            <div
              style="
                width:100%;
                margin-top: 28px;
                display: flex;
                align-items: center;
                justify-content: space-between;"
            >
            <span></span>
            <span>
              <a-pagination
                v-model="pageNoManage"
                :total="managetotal"
                show-less-items
                @change="handlepageNo"
              />
            </span>
            </div>
          </div>


          <!-- -----------------新增对话框 ----------------------------------->
          <a-modal
            title="新增"
            :visible="newBuildvisible"
            @ok="handleNewOk"
            @cancel="handleNewCancel"
          >
            <a-form-model
              :model="newBuildform"
              :rules="addNewRules"
              ref="ruleNewForm_add"
              style="display: flex"
            >
              <a-form-model-item label="分类标题" prop="name" style="display: flex">
                <a-input
                  placeholder="请输入"
                  v-model="newBuildform.name"
                  style="display: flex; margin-top: 5px; width: 220px"
                />
              </a-form-model-item>
            </a-form-model>
          </a-modal>

      <!---------------------- 编辑对话框------------------- -->
      <a-modal
        title="编辑"
        :visible="visible1"
        @ok="editOk"
        @cancel="editCancel"
      >
        <a-form-model
          :model="newBuildform"
          :rules="addNewRules"
          ref="ruleForm_edit"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              style="display: flex; margin-top: 5px; width: 220px"
              v-model="newBuildform.name"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

        <!-- </a-spin> -->
      </a-modal>

    </a-spin>
    <MessageAlert
      :visible="visibleAlert"
      v-on:closeMain="closeMainAlert"
    ></MessageAlert>
  </div>
</template>

<script>
import variables from "@/assets/base.scss";
import {
    updatedManagement,
  moveManagement,
} from "../../../service/columnmanageapi";
import {
  getManagement,
  getPicture,
  changePicture,
  delPicture,
  InsertImg,
  AddManagement,
} from "../../../service/columnmanageapi";
import { postImgList } from "@/service/document_api";
import NullDataPrompt from "../../../components/NullDataPrompt.vue";
import { admin_icon } from "@/utils/myIcon";
import MessageAlert from "@/components/Authentication/MessageAlert";
import { getAuthenticationInformation } from "@/service/authentication";
export default {
  name: "pictureControl",
  components: { NullDataPrompt, admin_con: admin_icon, MessageAlert },
  data() {
    return {
      // 管理 弹窗
      visible1:false,
      spin:false,
      remark: "",
      pageNoManage: 1,
      newBuildvisible:false,
      newBuildform: {
        name: "",
        code: "1",
      },
      addNewRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[^\s]+[\s]*.*$/i.test(value) == false) {
                callback(new Error("请输入正确的名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      pageSizeManage: 10,
      dataSource: [],
      managetotal: 0,
      modalShow:false,
      addform: {},
      columnsAdd: [
        {
          title: "序号",
          // width: "17%",
          key: "num",

          customRender: (text, record, index) =>
            `${(this.pageNoManage - 1) * this.pageSizeManage + (index + 1)}`,
        },

        {
          title: "名称",
          dataIndex: "title",
          // width: "24%",
          key: "title",
        },

        {
          title: "创建人",
          dataIndex: "createdByName",
          // width: "20%",
          key: "createdByName",
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          // width: "23%",
          key: "createdTime",
        },
        {
          title: "操作",
          dataIndex: "operation",
          // width: "25%",
          scopedSlots: { customRender: "is_operation" },
          key: "operation",
        },
      ],





      visibleAlert: false,
      form: {},
      addRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      visibleClass: false,
      spin: false,
      variables,
      innerWidths: null,
      year: [],
      topData: [],
      picture: [],
      typeid: "",
      imgName: "",
      pictureName: "",
      startTime: "",
      endTime: "",
      curPage: 1, //当前页
      total: 0, //总数
      pageSize: 8,
      showIndex: -1,
      selectIndex: -1, //圆孔显示
      boxShow: -1, //操作框显示
      inputshow: -1, //输入框显示
      visible: false, //分组弹窗显示
      category: {},
      iconList: [],
      categoryId: "",
      delVisible: false,
      delete: {},
      userInfoList: {},
      MessageShow1: false,
    };
  },
  created() {
    this.innerWidths = window.innerWidth; //屏幕宽度
    (this.pageSize = this.innerWidths > 0 && this.innerWidths < 1920 ? 10 : 12),
      this.load();
    this.getInformation();

  },
  methods: {
    // 删除
    delManage(record) {
      updatedManagement({
        id: record.id,
        title: record.title,
        code: record.code,
        delStatus: 1,
        type: "img",
      }).then((res) => {
        if (res.code == 200) {
          this.Manageload();
          this.load();
          this.$message.success("删除成功");
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    // 编辑确定
    editOk() {
      this.$refs.ruleForm_edit.validate(async (valid) => {
        if (valid) {
          updatedManagement({
            id: this.addform.id,
            title: this.newBuildform.name,
            code: this.addform.code,
            delStatus: 0,
            type: "img",
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功");
              this.visible1 = false;
              this.Manageload();
              this.load();
              this.$refs.ruleForm_edit.resetFields();
              this.newBuildform.name = "";
            } else {
              this.$message.warning("编辑失败");
            }
          });
        }
      });
    },
    // 编辑取消
    editCancel() {
      this.visible1 = false;
      this.newBuildform.name = "";
      this.newBuildform.code = "";
      this.Manageload();
      this.$refs.ruleForm_edit.resetFields();
      // this.spin = false;
    },
    // 打开编辑
    edit(record) {
      this.newBuildform.name = record.title;
      this.addform = record;
      this.visible1 = true;
    },
    //上移
    upMove(record) {
      moveManagement("up", record.id, "img").then((res) => {
        if (res.code == 0) {
          this.Manageload();
          this.load();
          this.$message.success("上移成功");
        } else {
          this.$message.warning("上移失败");
        }
      });
    },
    // 下移
    downMove(record) {
      moveManagement("down", record.id, "img").then((res) => {
        if (res.code == 0) {
          this.Manageload();
          this.load();
          this.$message.success("下移成功");
        } else {
          this.$message.warning("下移失败");
        }
      });
    },
    handlepageNo(pageNo, pageSize) {
      this.Manageload();
    },
    handleNewCancel(){
      this.newBuildvisible = false;
    },
    // 新增确定
    handleNewOk() {
      // this.spin = true;
      this.$refs.ruleNewForm_add.validate(async (valid) => {
        if (valid) {
          let form = {
            title: this.newBuildform.name,
            type: "img",
          };
          AddManagement(form).then((res) => {
            if (res.code == 200) {
              // this.spin = false;
              this.Manageload();
              this.load();
              this.$message.success("新增成功");
              this.newBuildvisible = false;
              this.newBuildform.name = "";
              this.$refs.ruleNewForm_add.resetFields();
            } else {
              this.$message.warning("新增失败");
              this.Manageload();
              this.$refs.ruleNewForm_add.resetFields();
            }
          });
        }
      });
    },
    // 打开新增
    add1Management() {
      if (!this.userInfoList.id) {
        this.visibleAlert = true;
      } else {
        this.newBuildvisible = true;
        this.newBuildform.name = "";
      }
    },
    searchManange() {
      this.pageNoManage = 1;
      this.Manageload();
    },
    // 获取全部数据类型
    Manageload() {
      // this.spin = true;
      getManagement({
        type: "img",
        title: this.remark,
        pageNo: this.pageNoManage,
        pageSize: this.pageSizeManage,
      }).then((res) => {
        this.dataSource = res.data;
        this.managetotal = res.count;
        // this.spin = false;
      });
    },

    Manageclear() {
      (this.remark = "",this.pageNoManage = 1), this.Manageload();
    },
    showModal(){
      this.modalShow = true
      this.pageNoManage = 1
      this.remark = ''
      this.Manageload()
    },
    handleSubmit(){
      this.modalShow = false
    },
    modalCancel(){
      this.modalShow = false
    },







    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
        // console.log("33", this.userInfoList.memberStatus);
        // if (this.userInfoList.memberStatus === 0) {
        if (!this.userInfoList.id) {
          this.MessageShow1 = true; //未认证的
        } else {
          this.MessageShow1 = false; //已认证的
        }
      } else {
        this.$message.warning("name", response.message);
      }
    },
    // 头部导航分类
    load() {
      this.spin = true;
      getManagement({
        type: "img",
        curPage: 1,
        pageSize: 9999,
      }).then((res) => {
        // console.log(res);
        this.topData = res.data;
        this.spin = false;
      });
      //  获取图片
      getPicture({
        columnId: this.typeid,
        name: this.imgName,
        startTime: this.startTime,
        endTime: this.endTime,
        curPage: this.curPage,
        pageSize: this.pageSize,
      }).then((res) => {
        // console.log(res);
        this.picture = res.data;
        this.total = res.count;
        this.spin = false;
      });
    },

    // 点击类别
    onChange(e) {
      this.curPage = 1;
      this.typeid = e.target.value;
      if (this.typeid == 0) {
        this.typeid = "";
      }
      this.load();
    },
    loadList() {
      this.visibleClass = true;
    },
    // 点击时间选择框
    timeChange(date, dateString) {
      this.year = dateString;
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 点击查询
    search() {
      this.curPage = 1;
      this.load();
    },
    change() {
      this.inputshow = -1;
      this.load();
      this.pictureName = "";
    },
    // 点击重置
    clear() {
      this.year = [];
      this.imgName = "";
      this.startTime = "";
      this.endTime = "";
      this.load();
    },
    // 改变页码
    PageNOchange(curPage) {
      this.curPage = curPage;
      this.load();
    },
    // 鼠标经过
    showYuan(index) {
      this.selectIndex = index;
      this.showIndex = index;
      // this.boxShow = -1;
    },
    //鼠标移开
    unshow() {
      this.selectIndex = -1;
    },
    changeboxShow(index) {
      this.boxShow = index;
    },
    // 重命名
    changeName(index, item) {
      this.pictureName = item.name;
      this.inputshow = index;
      // this.$refs["addLabel"].focus();
      this.$nextTick(function () {
        document.getElementById("addLabel").focus();
      });
    },

    // 输入框确定回调
    changeimgName(item) {
      changePicture({
        id: item.id,
        name: this.pictureName,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.inputshow = -1;
          this.load();
          this.pictureName = "";
        }
      });
    },

    // 打开删除
    del(item) {
      this.delete = item;
      // console.log(item);
      this.delVisible = true;
    },
    // 删除确定回调
    deleteOk() {
      delPicture(this.delete.id).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功");
          this.delVisible = false;
          this.load();
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    // 删除取消回调
    delCancel() {
      this.$message.warning("取消删除");
      this.delVisible = false;
      this.load();
    },
    // 点击移动分组回调 打开弹窗
    changeCategory(item) {
      this.visible = true;
      this.category.id = item.id;
      this.categoryId = item.columnId;
    },
    // 弹出框按钮回调
    handle(id) {
      this.category.columnId = id;
    },
    // 弹出框确定
    handleOk() {
      // console.log(this.category.columnId);
      changePicture({
        id: this.category.id,
        columnId: this.category.columnId,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.visible = false;
          this.categoryId = "";

          this.load();
        } else {
          this.$message.warning("修改失败");
          this.visible = false;
          this.categoryId = "";
          this.load();
        }
      });
    },
    handleOkClass() {
      this.$refs.ruleForm_add.validate((valid) => {
        if (valid) {
          let data = {
            title: this.form.name,
            type: "img",
          };
          this.postClass(data);
          this.form.name = "";
          this.visibleClass = false;
        }
      });
    },
    handleCancelClass() {
      this.visibleClass = false;
    },
    async postClass(data) {
      const response = await AddManagement(data);
      if (response.code === 200) {
        this.$message.success("新增成功！");
        await this.load();
      } else {
        this.$message.warning(response.message);
      }
    },
    // 弹出框取消
    handleCancel() {
      this.categoryId = "";
      this.visible = false;
      this.load();
    },
    // 批量上传图片
    async up_iconList(name) {
      this.spin = true;
      //账号类型 0未认证 1个人认证 2企业认证
      const fileList = document.getElementById("files").files;
      // console.log("图片", fileList);
      let formData = new FormData();
      for (const file of fileList) {
        let picture = {};

        let str = file.name;
        let index = str.indexOf("."); // 获取元素在字符串中的索引位置
        let result = str.substring(0, index); // 使用substring()方法截取从0到index的子字符串

        picture.name = result;
        formData.append("file", file);
        const image = await postImgList(formData);
        if (image.code === 0) {
          for (const images of image.data.url) {
            picture.url = images;
          }
          this.iconList.push({
            url: picture.url,
            name: picture.name,
            columnId: this.typeid,
          });
        }
        InsertImg(this.iconList).then((res) => {
          if (res.code == 0) {
            this.spin = false;
            this.load();
            this.iconList = [];
            this.$message.success("上传成功");
          } else {
            this.spin = false;
            this.load();
            this.iconList = [];
            this.$message.warning("上传失败");
          }
        });
      }
    },

    closeMainAlert(val) {
      this.visibleAlert = val;
    },

    openMessage() {
      this.visibleAlert = true;
    },
  },
};
</script>

<style scoped lang="scss">
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.66666%;
}

.pictureControl {
  width: 100%;
  min-height: 100%;
  border: 10px solid #edeff2;
}
.top {
  width: 100%;
  height: 130px;
  .iconSheZhi {
    font-size: 20px;
    cursor: pointer;
  }
  .classTitle {
    width: 100%;
    height: 50%;
    border-bottom: 1px solid #edeff2;
    .title {
      margin-left: 1%;
      display: inline-block;
      padding-top: 20px;
      color: $topTitleColor;
    }
    .content {
      color: $topNameColor;
      margin-left: 5px;
    }
  }
  .selectTop {
    width: 98%;
    height: 50%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    margin-top: 15px;
  }
}
.topTitle {
  color: $topTitleColor;
}
.ant-radio-button-wrapper {
  border-radius: 5px;
  border: none;
  &::before {
    display: none; // 隐藏分界线
  }
}
::v-deep .ant-radio-button-wrapper::before {
  display: none;
}
.bottom {
  width: 100%;
  min-height: 480px;
}
.item {
  position: relative;
  width: 100%;
  height: 230px;
  border: 1.3px solid #edeff2;
  .yuan {
    position: absolute;
    top: 0%;
    right: 1.5%;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: white;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .box {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 70px;
  }
}
.moTitle {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: auto;
  height: 50px;
  line-height: 50px;
  .font {
    font-weight: 600;
    color: $topTitleColor;
  }
}

.file {
  position: relative;
  display: inline-block;
  background: #1890ff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: white;
  font-size: 15px;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
}
.file input {
  position: absolute;
  font-size: 110px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: #1890ff;
  color: white;
  text-decoration: none;
}
/* 按钮样式 */
.dropdown-button {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background: white;
  text-align: center;
  line-height: 40px;
}

/* 下拉菜单 */
.dropdown-menu {
  /* 默认不显示 */
  display: none;
  /* 设置宽度 */
  width: 80px;
  /* 设置边框 */
  // border: 2px solid #e5f1fb;
  margin-top: 35px;
  border-radius: 5px;
  background-color: white;
}
/* 鼠标悬停时，显示菜单区域 */
.dropdown:hover .dropdown-menu {
  display: block;
}
/* 链接样式 */
.dropdown-menu a {
  /* 换行 */
  display: block;
  /* 黑色字体 */
  color: $topNameColor;
  /* 增大间距 */
  padding: 8px 12px;
  /* 去掉下划线 */
  text-decoration: none;
}

/* 整个下拉菜单 */
.dropdown {
  display: inline-block;
  position: absolute;
  top: 2px;
  right: 8px;
}
// ::v-deep .ant-modal-content .ant-modal-header {
//   border-bottom: none !important;
// }

// ::v-deep .ant-modal-content .ant-modal-footer {
//   border-top: none !important;
// }




.ant-spin-nested-loading {
  width: 100%;
  min-height: 280px;
  height: 100%;
}

.ant-table-thead > tr > th {
  font-size: 17px;
  font-weight: 550;
}
.ant-pagination {
  width: 98%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.top2 {
  width: $space_div;
  margin: auto;
  height: 60px;
  padding-top: 15px;
}
.liebiao {
  width: 100%;
  border-bottom: 1px solid rgb(238, 233, 233);
  .title {
    color: $topNameColor;
    font-weight: 600;
    height: 50px;
    line-height: 50px;
    width: $space_div;
    margin: auto;
  }
}
</style>
